import { commonTranslationKeys } from '@dreryk/react-common';
import { ActionBar, ButtonVariant } from '@dreryk/react-components';

import { NfzLoginFormController } from './NfzLoginForm.types';
import { useEzwmChangePasswordCommand } from './NfzLoginSaveAction.hooks';
import { PasswordChangeEnabledFormBeanPart } from './fields/PasswordChangeEnabledField';
import { EzwmEnabledFormBeanPart } from './fields/EzwmEnabledField';

type EzwmNewPasswordSaveActionProps = Pick<
   NfzLoginFormController<PasswordChangeEnabledFormBeanPart<true> & EzwmEnabledFormBeanPart<true>>,
   'handleSubmit'
> & { onSuccess: VoidFunction };

export const EzwmNewPasswordSaveAction = (props: EzwmNewPasswordSaveActionProps): JSX.Element => {
   const { executeAsync: changePasswordInEzwm } = useEzwmChangePasswordCommand({
      onSuccess: props.onSuccess,
   });

   return (
      <ActionBar.PrimaryButton
         testId={'nfzChangePassword'}
         label={commonTranslationKeys.save}
         onClick={props.handleSubmit(changePasswordInEzwm)}
         variant={ButtonVariant.PRIMARY}
         order={1}
      />
   );
};
